import DiskUsageByFolder from "../Components/Pages/Linux/DiskUsageByFolder/DiskUsageByFolder";
import BashLoops from "../Components/Pages/Bash/BashLoops/BashLoops";
import RegularExpressions from "../Components/Pages/Bash/RegularExpressions/RegularExpressions";
import DiskQuota from "../Components/Pages/Linux/DiskQuota/DiskQuota";
import ManageJvmCacerts from "../Components/Pages/Linux/ManageJvmCacerts/ManageJvmCacerts";
import PresharedKeyAuthentication
    from "../Components/Pages/Linux/PresharedKeyAuthentication/PresharedKeyAuthentication";
import KillSlowQueries from "../Components/Pages/Linux/KillLongQueries/KillSlowQueries";
import ToBigDigits from "../Components/Pages/Python/ToBigDigits/ToBigDigits";
import Average from "../Components/Pages/Python/Average/Average";
import RsaFileEncryption from "../Components/Pages/Python/RsaFileEncryption/RsaFileEncryption";
import DuplicateFileFinder from "../Components/Pages/Python/DuplicateFileFinder/DuplicateFileFinder";
import TotpGenerator from "../Components/Pages/Python/TotpGenerator/TotpGenerator";
import MandelbrotSet from "../Components/Pages/Python/MandelbrotSet/MandelbrotSet";
import PasswordGenerator from "../Components/Pages/Python/PasswordGenerator/PasswordGenerator";
import PdfMerger from "../Components/Pages/Python/PdfMerger/PdfMerger";
import SecretsScanner from "../Components/Pages/Python/SecretsScanner/SecretsScanner";
import SslExpiryChecker from "../Components/Pages/Python/SslExpiryChecker/SslExpiryChecker";
import FileOrganizer from "../Components/Pages/Python/FileOrganizer/FileOrganizer";
import BackupRotation from "../Components/Pages/Python/BackupRotation/BackupRotation";
import BrokenLinkChecker from "../Components/Pages/Python/BrokenLinkChecker/BrokenLinkChecker";
import QrCodeGenerator from "../Components/Pages/Python/QrCodeGenerator/QrCodeGenerator";
import BashArrays from "../Components/Pages/Bash/BashArrays/BashArrays";
import BashEncryption from "../Components/Pages/Bash/BashEncryption/BashEncryption";
import Directories from "../Components/Pages/Linux/Directories/Directories";
import MountRemoteSharesCifs from "../Components/Pages/Bash/MountRemoteSharesCifs/MountRemoteSharesCifs";
import FilePermissions from "../Components/Pages/Linux/FilePermissions/FilePermissions";
import UsersAndGroups from "../Components/Pages/Linux/UsersAndGroups/UsersAndGroups";
import SystemdCheatSheet from "../Components/Pages/Linux/SystemdCheatSheet/SystemdCheatSheet";
import AutostartOnBoot from "../Components/Pages/Linux/AutostartOnBoot/AutostartOnBoot";
import ProcessManagement from "../Components/Pages/Linux/ProcessManagement/ProcessManagement";
import CronJobs from "../Components/Pages/Linux/CronJobs/CronJobs";
import CheckOpenPorts from "../Components/Pages/Linux/CheckOpenPorts/CheckOpenPorts";
import FirewallBasics from "../Components/Pages/Linux/FirewallBasics/FirewallBasics";
import SshTunneling from "../Components/Pages/Linux/SshTunneling/SshTunneling";
import SshClientConfig from "../Components/Pages/Linux/SshClientConfig/SshClientConfig";
import DiskPartitioningLvm from "../Components/Pages/Linux/DiskPartitioningLvm/DiskPartitioningLvm";
import RsyncCheatSheet from "../Components/Pages/Linux/RsyncCheatSheet/RsyncCheatSheet";
import TarGzipCompression from "../Components/Pages/Linux/TarGzipCompression/TarGzipCompression";
import Inodes from "../Components/Pages/Linux/Inodes/Inodes";
import Logrotate from "../Components/Pages/Linux/Logrotate/Logrotate";
import Journalctl from "../Components/Pages/Linux/Journalctl/Journalctl";
import StringManipulation from "../Components/Pages/Bash/StringManipulation/StringManipulation";
import ParameterExpansion from "../Components/Pages/Bash/ParameterExpansion/ParameterExpansion";
import BashFunctions from "../Components/Pages/Bash/BashFunctions/BashFunctions";
import TestOperators from "../Components/Pages/Bash/TestOperators/TestOperators";
import PatternMatching from "../Components/Pages/Bash/PatternMatching/PatternMatching";
import BashArithmetic from "../Components/Pages/Bash/BashArithmetic/BashArithmetic";
import Redirection from "../Components/Pages/Bash/Redirection/Redirection";
import Heredocs from "../Components/Pages/Bash/Heredocs/Heredocs";
import ReadingInput from "../Components/Pages/Bash/ReadingInput/ReadingInput";
import PipelinesAndExitStatus from "../Components/Pages/Bash/PipelinesAndExitStatus/PipelinesAndExitStatus";
import ProcessSubstitution from "../Components/Pages/Bash/ProcessSubstitution/ProcessSubstitution";
import CommandSubstitution from "../Components/Pages/Bash/CommandSubstitution/CommandSubstitution";
import Getopts from "../Components/Pages/Bash/Getopts/Getopts";
import TrapsAndSignals from "../Components/Pages/Bash/TrapsAndSignals/TrapsAndSignals";
import StrictModeDebugging from "../Components/Pages/Bash/StrictModeDebugging/StrictModeDebugging";
import SubshellsAndGrouping from "../Components/Pages/Bash/SubshellsAndGrouping/SubshellsAndGrouping";
import JobControl from "../Components/Pages/Bash/JobControl/JobControl";
import ParallelExecution from "../Components/Pages/Bash/ParallelExecution/ParallelExecution";
import FindAndXargs from "../Components/Pages/Bash/FindAndXargs/FindAndXargs";
import SedBasics from "../Components/Pages/Bash/SedBasics/SedBasics";
import AwkBasics from "../Components/Pages/Bash/AwkBasics/AwkBasics";
import Checksums from "../Components/Pages/Bash/Checksums/Checksums";
import AnsiColors from "../Components/Pages/Bash/AnsiColors/AnsiColors";
import BashHistory from "../Components/Pages/Bash/BashHistory/BashHistory";
import ZipAllFolders from "../Components/Pages/Bash/ZipAllFolders/ZipAllFolders";
import RequestResponseVsEvents from "../Components/Pages/Architecture/RequestResponseVsEvents/RequestResponseVsEvents";
import SqlVsNosql from "../Components/Pages/Architecture/SqlVsNosql/SqlVsNosql";
import StrongVsEventualConsistency from "../Components/Pages/Architecture/StrongVsEventualConsistency/StrongVsEventualConsistency";
import Idempotency from "../Components/Pages/Architecture/Idempotency/Idempotency";
import MonolithVsMicroservices from "../Components/Pages/Architecture/MonolithVsMicroservices/MonolithVsMicroservices";
import CachingAndInvalidation from "../Components/Pages/Architecture/CachingAndInvalidation/CachingAndInvalidation";
import ApiStyles from "../Components/Pages/Architecture/ApiStyles/ApiStyles";
import VerticalVsHorizontalScaling from "../Components/Pages/Architecture/VerticalVsHorizontalScaling/VerticalVsHorizontalScaling";
import DatabaseReplication from "../Components/Pages/Architecture/DatabaseReplication/DatabaseReplication";
import BrokerPatterns from "../Components/Pages/Architecture/BrokerPatterns/BrokerPatterns";
import ResiliencePatterns from "../Components/Pages/Architecture/ResiliencePatterns/ResiliencePatterns";
import ShardingAndPartitioning from "../Components/Pages/Architecture/ShardingAndPartitioning/ShardingAndPartitioning";
import RateLimitingAndBackpressure from "../Components/Pages/Architecture/RateLimitingAndBackpressure/RateLimitingAndBackpressure";
import ConsensusAndLeaderElection from "../Components/Pages/Architecture/ConsensusAndLeaderElection/ConsensusAndLeaderElection";
import DistributedTransactions from "../Components/Pages/Architecture/DistributedTransactions/DistributedTransactions";
import MultiRegionDeployment from "../Components/Pages/Architecture/MultiRegionDeployment/MultiRegionDeployment";
import Observability from "../Components/Pages/Architecture/Observability/Observability";
import ApiAndSchemaEvolution from "../Components/Pages/Architecture/ApiAndSchemaEvolution/ApiAndSchemaEvolution";
import BatchVsStreamProcessing from "../Components/Pages/Architecture/BatchVsStreamProcessing/BatchVsStreamProcessing";
import MultiTenancyModels from "../Components/Pages/Architecture/MultiTenancyModels/MultiTenancyModels";
import BehindThisSite from "../Components/Pages/Infrastructure/BehindThisSite/BehindThisSite";
import NginxCertbotMcp from "../Components/Pages/Portfolio/NginxCertbotMcp/NginxCertbotMcp";
import KubernetesCheatSheet from "../Components/Pages/Kubernetes/KubernetesCheatSheet/KubernetesCheatSheet";
import KubeadmClusterSetup from "../Components/Pages/Kubernetes/KubeadmClusterSetup/KubeadmClusterSetup";
import RegistryPullSecret from "../Components/Pages/Kubernetes/RegistryPullSecret/RegistryPullSecret";
import HelmCheatSheet from "../Components/Pages/Kubernetes/Helm/HelmCheatSheet/HelmCheatSheet";
import ArgoCdCheatSheet from "../Components/Pages/Kubernetes/ArgoCd/ArgoCdCheatSheet/ArgoCdCheatSheet";

const sitePages = [
    {
        to: '/linux',
        title: 'Linux',
        children: [
            {
                to: '/disk-usage-by-folder',
                title: 'Disk usage by folder',
                component: DiskUsageByFolder
            },
            {
                to: '/set-disk-quota',
                title: 'Set disk quota',
                component: DiskQuota
            },
            {
                to: '/manage-jvm-cacerts',
                title: 'Manage JVM cacerts',
                component: ManageJvmCacerts
            },
            {
                to: '/pre-shared-keys',
                title: 'SSH Key Auth',
                component: PresharedKeyAuthentication
            },
            {
                to: '/kill-slow-queries',
                title: 'Kill Slow Queries',
                component: KillSlowQueries
            },
            {
                to: '/directories',
                title: 'Directories',
                component: Directories
            },
            {
                to: '/file-permissions',
                title: 'File permissions',
                component: FilePermissions
            },
            {
                to: '/users-and-groups',
                title: 'Users & groups',
                component: UsersAndGroups
            },
            {
                to: '/systemd-cheat-sheet',
                title: 'Systemd cheat sheet',
                component: SystemdCheatSheet
            },
            {
                to: '/autostart-on-boot',
                title: 'Autostart on boot',
                component: AutostartOnBoot
            },
            {
                to: '/process-management',
                title: 'Process management',
                component: ProcessManagement
            },
            {
                to: '/cron-jobs',
                title: 'Cron jobs',
                component: CronJobs
            },
            {
                to: '/check-open-ports',
                title: 'Check open ports',
                component: CheckOpenPorts
            },
            {
                to: '/firewall-basics',
                title: 'Firewall basics',
                component: FirewallBasics
            },
            {
                to: '/ssh-tunneling',
                title: 'SSH tunneling',
                component: SshTunneling
            },
            {
                to: '/ssh-client-config',
                title: 'SSH client configuration (~/.ssh/config)',
                component: SshClientConfig
            },
            {
                to: '/disk-partitioning-lvm',
                title: 'Disk partitioning & LVM',
                component: DiskPartitioningLvm
            },
            {
                to: '/rsync-cheat-sheet',
                title: 'Rsync cheat sheet',
                component: RsyncCheatSheet
            },
            {
                to: '/tar-gzip-compression',
                title: 'Tar & compression',
                component: TarGzipCompression
            },
            {
                to: '/inodes-explained',
                title: 'Inodes explained',
                component: Inodes
            },
            {
                to: '/logrotate',
                title: 'Logrotate',
                component: Logrotate
            },
            {
                to: '/journalctl',
                title: 'Journalctl',
                component: Journalctl
            },
        ]
    },
    {
        to: '/python',
        title: 'Python',
        children: [
            {
                to: '/integer-to-big-digits',
                title: 'To big digits',
                component: ToBigDigits
            },
            {
                to: '/average-calculator',
                title: 'Average calculator',
                component: Average
            },
            {
                to: '/rsa-file-encryption',
                title: 'RSA file encryption',
                component: RsaFileEncryption
            },
            {
                to: '/duplicate-file-finder',
                title: 'Duplicate file finder',
                component: DuplicateFileFinder
            },
            {
                to: '/totp-generator',
                title: 'TOTP generator',
                component: TotpGenerator
            },
            {
                to: '/mandelbrot-set',
                title: 'Mandelbrot set',
                component: MandelbrotSet
            },
            {
                to: '/password-generator',
                title: 'Password generator',
                component: PasswordGenerator
            },
            {
                to: '/pdf-merger',
                title: 'PDF merger',
                component: PdfMerger
            },
            {
                to: '/secrets-scanner',
                title: 'Secrets scanner',
                component: SecretsScanner
            },
            {
                to: '/ssl-expiry-checker',
                title: 'SSL expiry checker',
                component: SslExpiryChecker
            },
            {
                to: '/file-organizer',
                title: 'Auto file organizer',
                component: FileOrganizer
            },
            {
                to: '/backup-rotation',
                title: 'Backup with rotation',
                component: BackupRotation
            },
            {
                to: '/broken-link-checker',
                title: 'Broken link checker',
                component: BrokenLinkChecker
            },
            {
                to: '/qr-code-generator',
                title: 'QR code generator',
                component: QrCodeGenerator
            }
        ]
    },
    {
        to: '/bash',
        title: 'Bash',
        children: [
            {
                to: '/bash-loops',
                title: 'Loops',
                component: BashLoops
            },
            {
                to: '/bash-encrypt',
                title: 'Encryption',
                component: BashEncryption
            },
            {
                to: '/regular-expressions',
                title: 'Regular expressions',
                component: RegularExpressions
            },
            {
                to: '/bash-arrays',
                title: 'Arrays',
                component: BashArrays
            },
            {
                to: '/mount-remote-shares-cifs',
                title: "Mount CIFS",
                component: MountRemoteSharesCifs
            },
            {
                to: '/bash-string-manipulation',
                title: 'String manipulation',
                component: StringManipulation
            },
            {
                to: '/bash-parameter-expansion',
                title: 'Parameter expansion',
                component: ParameterExpansion
            },
            {
                to: '/bash-functions',
                title: 'Functions',
                component: BashFunctions
            },
            {
                to: '/bash-test-operators',
                title: 'Test operators',
                component: TestOperators
            },
            {
                to: '/bash-pattern-matching',
                title: 'Pattern matching & case',
                component: PatternMatching
            },
            {
                to: '/bash-arithmetic',
                title: 'Arithmetic',
                component: BashArithmetic
            },
            {
                to: '/bash-redirection',
                title: 'Redirection',
                component: Redirection
            },
            {
                to: '/bash-heredocs',
                title: 'Here-docs & here-strings',
                component: Heredocs
            },
            {
                to: '/bash-reading-input',
                title: 'Reading input',
                component: ReadingInput
            },
            {
                to: '/bash-pipelines-exit-status',
                title: 'Pipelines & exit status',
                component: PipelinesAndExitStatus
            },
            {
                to: '/bash-process-substitution',
                title: 'Process substitution',
                component: ProcessSubstitution
            },
            {
                to: '/bash-command-substitution',
                title: 'Command substitution',
                component: CommandSubstitution
            },
            {
                to: '/bash-getopts',
                title: 'Argument parsing (getopts)',
                component: Getopts
            },
            {
                to: '/bash-traps-signals',
                title: 'Traps & signal handling',
                component: TrapsAndSignals
            },
            {
                to: '/bash-debugging',
                title: 'Strict mode & debugging',
                component: StrictModeDebugging
            },
            {
                to: '/bash-subshells',
                title: 'Subshells & command grouping',
                component: SubshellsAndGrouping
            },
            {
                to: '/bash-job-control',
                title: 'Job control',
                component: JobControl
            },
            {
                to: '/bash-parallel',
                title: 'Parallel execution',
                component: ParallelExecution
            },
            {
                to: '/find-and-xargs',
                title: 'find + xargs',
                component: FindAndXargs
            },
            {
                to: '/sed-basics',
                title: 'sed basics',
                component: SedBasics
            },
            {
                to: '/awk-basics',
                title: 'awk basics',
                component: AwkBasics
            },
            {
                to: '/checksums-hashing',
                title: 'Checksums & hashing',
                component: Checksums
            },
            {
                to: '/ansi-colors',
                title: 'ANSI color output',
                component: AnsiColors
            },
            {
                to: '/bash-history',
                title: 'History tricks',
                component: BashHistory
            },
            {
                to: '/zip-all-folders',
                title: 'Zip each folder',
                component: ZipAllFolders
            }
        ]
    },
    {
        to: '/architecture',
        title: 'Architecture',
        children: [
            {
                to: '/architecture/request-response-vs-events',
                title: 'Request/response vs. events',
                component: RequestResponseVsEvents
            },
            {
                to: '/architecture/sql-vs-nosql',
                title: 'SQL vs. NoSQL',
                component: SqlVsNosql
            },
            {
                to: '/architecture/consistency',
                title: 'Strong vs. eventual consistency',
                component: StrongVsEventualConsistency
            },
            {
                to: '/architecture/idempotency',
                title: 'Idempotency',
                component: Idempotency
            },
            {
                to: '/architecture/monolith-vs-microservices',
                title: 'Monolith vs. microservices',
                component: MonolithVsMicroservices
            },
            {
                to: '/architecture/caching',
                title: 'Caching and invalidation',
                component: CachingAndInvalidation
            },
            {
                to: '/architecture/api-styles',
                title: 'REST vs. GraphQL vs. gRPC',
                component: ApiStyles
            },
            {
                to: '/architecture/scaling',
                title: 'Vertical vs. horizontal scaling',
                component: VerticalVsHorizontalScaling
            },
            {
                to: '/architecture/database-replication',
                title: 'Synchronous vs. asynchronous replication',
                component: DatabaseReplication
            },
            {
                to: '/architecture/broker-patterns',
                title: 'Queue vs. pub/sub vs. log',
                component: BrokerPatterns
            },
            {
                to: '/architecture/resilience-patterns',
                title: 'Timeouts, retries & circuit breakers',
                component: ResiliencePatterns
            },
            {
                to: '/architecture/sharding-and-partitioning',
                title: 'Sharding & partitioning',
                component: ShardingAndPartitioning
            },
            {
                to: '/architecture/rate-limiting-and-backpressure',
                title: 'Rate limiting & backpressure',
                component: RateLimitingAndBackpressure
            },
            {
                to: '/architecture/consensus-and-leader-election',
                title: 'Consensus & leader election',
                component: ConsensusAndLeaderElection
            },
            {
                to: '/architecture/distributed-transactions',
                title: 'Distributed transactions: 2PC vs. Saga',
                component: DistributedTransactions
            },
            {
                to: '/architecture/multi-region-deployment',
                title: 'Active-active vs. active-passive',
                component: MultiRegionDeployment
            },
            {
                to: '/architecture/observability',
                title: 'Logs, metrics & traces',
                component: Observability
            },
            {
                to: '/architecture/api-and-schema-evolution',
                title: 'API & schema evolution',
                component: ApiAndSchemaEvolution
            },
            {
                to: '/architecture/batch-vs-stream-processing',
                title: 'Batch vs. stream processing',
                component: BatchVsStreamProcessing
            },
            {
                to: '/architecture/multi-tenancy-models',
                title: 'Multi-tenancy models',
                component: MultiTenancyModels
            }
        ]
    },
    {
        to: '/infrastructure',
        title: 'Infrastructure',
        children: [
            {
                to: '/infrastructure/behind-this-site',
                title: 'Behind this site',
                component: BehindThisSite
            }
        ]
    },
    {
        to: '/portfolio',
        title: 'Portfolio',
        children: [
            {
                to: '/portfolio/nginx-certbot-mcp',
                title: 'nginx-certbot-mcp',
                component: NginxCertbotMcp
            }
        ]
    },
    {
        to: '/kubernetes',
        title: 'Kubernetes',
        children: [
            {
                to: '/kubernetes/cheat-sheet',
                title: 'Kubernetes in a nutshell',
                component: KubernetesCheatSheet
            },
            {
                to: '/kubernetes/kubeadm-cluster',
                title: 'Cluster from scratch (kubeadm)',
                component: KubeadmClusterSetup
            },
            {
                to: '/kubernetes/registry-pull-secret',
                title: 'Private registry pull secret',
                component: RegistryPullSecret
            },
            {
                to: '/kubernetes/helm',
                title: 'Helm in a nutshell',
                component: HelmCheatSheet
            },
            {
                to: '/kubernetes/argocd',
                title: 'Argo CD in a nutshell',
                component: ArgoCdCheatSheet
            }
        ]
    }
]

export default sitePages
//
// let sample = {
//     to: '/page-four',
//     title: 'Page Four',
//     children: [
//         {
//             to: '/page-one',
//             title: 'Child one',
//             component: ''
//         },
//         {
//             to: '/page-two',
//             title: 'Child two',
//             component: '',
//             children: [
//                 {
//                     to: '/page-one',
//                     title: 'Child one',
//                     component: ''
//                 },
//                 {
//                     to: '/page-two',
//                     title: 'Child two',
//                     children: [
//                         {
//                             to: '/page-one',
//                             title: 'Child one',
//                             component: ''
//                         },
//                         {
//                             to: '/page-two',
//                             title: 'Child two',
//                             children: [
//                                 {
//                                     to: '/page-one',
//                                     title: 'Child one',
//                                     component: ''
//                                 },
//                                 {
//                                     to: '/page-two',
//                                     title: 'Child two',
//                                     component: ''
//                                 },
//                                 {
//                                     to: '/page-three',
//                                     title: 'Child three',
//                                     component: ''
//                                 },
//                                 {
//                                     to: '/page-four',
//                                     title: 'Child four',
//                                     component: ''
//                                 }
//                             ]
//                         },
//                         {
//                             to: '/page-three',
//                             title: 'Child three',
//                             component: ''
//                         },
//                         {
//                             to: '/page-four',
//                             title: 'Child four',
//                             component: ''
//                         }
//                     ]
//                 },
//                 {
//                     to: '/page-three',
//                     title: 'Child three',
//                     component: ''
//                 },
//                 {
//                     to: '/page-four',
//                     title: 'Child four',
//                     component: ''
//                 }
//             ]
//         },
//         {
//             to: '/page-three',
//             title: 'Child three',
//             component: ''
//         },
//         {
//             to: '/page-four',
//             title: 'Child four',
//             component: ''
//         }
//     ]
// }